export default {
    MailingSettingsBtnSave: 'MailingSettingsBtnSave',
    MailingSelectedAllBtn: 'MailingSelectedAllBtn',
    CrmPageMailingList: 'CrmPageMailingList',
    CrmPageMailingStepper: 'CrmPageMailingStepper',
    CrmBtnMailingDelete: 'CrmBtnMailingDelete',
    CrmBtnMailingEdit: 'CrmBtnMailingEdit',
    CrmBtnMailingSendNow: 'CrmBtnMailingSendNow',
    MailingAdmin: 'MailingAdmin'
};

